// Generated by scripts/build-ui-icons.mjs.
export { Shield as default } from "../ui/glyphs-6";
